import styled from "styled-components";

export const RadioContainer = styled.label<{ selected: boolean }>`
  width: 100%;
  display: block;
  flex-direction: column;
  border: 2px solid #bdbdbd;
  border: ${({ selected }) =>
    selected ? "2px solid #000" : "2px solid #bdbdbd"};
  border-radius: 0.5rem;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  text-align: center;
`;

export const RadioInput = styled.input<{ color: string; img: string }>`
  appearance: none;
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0 auto;
  &::before {
    content: "";
    min-width: 2rem;
    min-height: 2rem;
    background: ${({ img }) => `url(${img})`};
    display: inline-block;
    background-size: 90%;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

export const RadioLabel = styled.div`
  font-size: 1rem;
`;
